<template>
  <div class="humanResources">
    <div class="box_1 flex-col">
      <div class="group_3 flex-row">
        <div class="text-wrapper_1 flex-col" @click="showIndex()">
          <span class="text_13">联系我们</span>
          <span class="text_14">0311-67300762&nbsp;/&nbsp;67596720</span>
        </div>
        <div class="text-wrapper_2 flex-col" @click="showEmail()">
          <span class="text_15">简历投递邮箱</span>
          <span class="text_16">xhrs&#64;sailhero.com.cn</span>
        </div>
        <div class="text-wrapper_3 flex-col" @click="showBasicInformation()">
          <span class="text_17">企业基本情况</span>
        </div>
        <div class="text-wrapper_4 flex-col" @click="showJobOpenings()">
          <span class="text_18">招聘岗位</span>
        </div>
      </div>
    </div>
    <div class="box_3 flex-col" v-if="indexShow || emailShow">
      <div class="box_4 flex-row">
        <div class="text-wrapper_5 flex-col justify-between">
          <span class="text_19">当前位置：首页&nbsp;&gt;&nbsp;人力资源</span>
          <span class="text_20">人力资源</span>
        </div>
        <div class="text-wrapper_6_be">
          <transition  name="slide">
            <div class="text-wrapper_6 flex-col" v-if="telshow">
              <span class="text_21">4001-300-137</span>
            </div>
          </transition>
        </div>
        <div class="box_8_1">
          <div class="section_1 flex-row" style="cursor:pointer"  @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
            <div class="image-text_1 flex-col justify-between">
              <img class="label_1" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/icon_lxfs.png')"/>
              <span class="text-group_1">业务咨询</span>
            </div>
          </div>
        </div>
      </div>
      <img class="image_2" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/dx_1.jpg')"/>
      <div class="box_5 flex-row justify-end">
        <img class="box_6" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/ds_5.jpg')"/>
        <div class="text-wrapper_8 flex-col">
          <span class="text_24">人才政策</span>
          <span class="paragraph_0">人才是先河环保的第一资源。先河环保始终把人才作为企业发展的创业之本、竞争之本、发展之本。经过二十多年地不断发展已经形成了公开、公正、公平、尊重知识和人才的良好企业风气。公司以其独特的人才招聘战略、开阔的事业发展空间、优良的人才成长环境、有效的激励机制和人本的企业文化理念，是企业成为人才集聚的高地。</span>
          <span class="paragraph_11">用人原则：德才兼备，以德为先；用人之道：用人之愿、用人之潜、用人之长。</span>
        </div>
      </div>
      <div class="box_11 flex-col">
        <div class="group_5 flex-row justify-between">
          <div class="group_6 flex-col"></div>
          <div class="image-text_2 flex-row justify-between">
            <span class="text-group_2">薪酬福利</span>
            <div class="group_7 flex-col"></div>
          </div>
        </div>
        <div class="list_1 flex-row">
          <div class="list-items_1 flex-col"></div>
          <div class="list-items_2 flex-col"></div>
          <div class="list-items_3 flex-col"></div>
          <div class="list-items_4 flex-col"></div>
        </div>
        <div class="text-wrapper_9 flex-row">
          <span class="text_25">01</span> <span class="text_26">基本薪资</span>
          <span class="text_27">02</span> <span class="text_28">绩效奖金</span>
          <span class="text_29">03</span> <span class="text_30">全面福利</span>
          <span class="text_31">04</span> <span class="text_32">补充津贴</span>
        </div>
        <div class="image-wrapper_1 flex-row justify-between">
          <img class="image_3" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/ds_0.png')"/>
          <img class="image_4" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/ds_0.png')"/>
          <img class="image_5" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/ds_0.png')"/>
          <img class="image_6" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/ds_0.png')"/>
        </div>
        <div class="group_8 flex-row">
          <div class="image-text_3 flex-row justify-between">
            <img
                class="thumbnail_3"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/tb0.png')"
            />
            <span class="text-group_3">行业具有竞争力的薪酬水平</span>
          </div>
          <div class="image-text_4 flex-row justify-between">
            <img
                class="thumbnail_4"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/tb0.png')"
            />
            <span class="text-group_4">日常奖励</span>
          </div>
          <div class="image-text_5 flex-row justify-between">
            <img
                class="thumbnail_5"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/tb0.png')"
            />
            <span class="text-group_5">专项奖励</span>
          </div>
          <div class="image-text_6 flex-row justify-between">
            <img
                class="thumbnail_6"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/tb0.png')"
            />
            <span class="text-group_6">五险一金</span>
          </div>
          <div class="image-text_7 flex-row justify-between">
            <img
                class="thumbnail_7"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/tb0.png')"
            />
            <span class="text-group_7">免费通勤</span>
          </div>
          <div class="image-text_8 flex-row justify-between">
            <img
                class="thumbnail_8"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/tb0.png')"
            />
            <span class="text-group_8">通讯补贴</span>
          </div>
          <div class="image-text_9 flex-row justify-between">
            <img
                class="thumbnail_9"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/tb0.png')"
            />
            <span class="text-group_9">出差补贴</span>
          </div>
        </div>
        <div class="group_9 flex-row">
          <div class="image-text_10 flex-row justify-between">
            <img
                class="thumbnail_10"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/tb0.png')"
            />
            <span class="text-group_10">每年职评调薪机会</span>
          </div>
          <img
              class="thumbnail_11"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text_33">年度绩效奖励</span>
          <img
              class="thumbnail_12"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text_34">营销专项奖励</span>
          <div class="image-text_11 flex-row justify-between">
            <img
                class="thumbnail_13"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/tb0.png')"
            />
            <span class="text-group_11">成本价午餐</span>
          </div>
          <div class="image-text_12 flex-row justify-between">
            <img
                class="thumbnail_14"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/tb0.png')"
            />
            <span class="text-group_12">节假日福利</span>
          </div>
          <img
              class="thumbnail_15"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text_35">年度评优奖励</span>
          <img
              class="thumbnail_16"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text_36">年度业绩奖金</span>
        </div>
        <div class="group_10 flex-row">
          <img
              class="thumbnail_17"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text_37">技术专项奖励</span>
          <img
              class="thumbnail_18"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text_38">成本节约专项奖励</span>
          <div class="image-text_13 flex-row justify-between">
            <img
                class="thumbnail_19"
                referrerpolicy="no-referrer"
                :src="require('@/assets/humanResources/img/tb0.png')"
            />
            <span class="text-group_13">文体娱乐活动</span>
          </div>
        </div>
        <div class="image-text_14 flex-row justify-between">
          <img
              class="thumbnail_20"
              referrerpolicy="no-referrer"
              :src="require('@/assets/humanResources/img/tb0.png')"
          />
          <span class="text-group_14">利润贡献专项奖励</span>
        </div>
      </div>
      <div class="box_12 flex-row justify-between">
        <div class="block_1 flex-col"></div>
        <div class="image-text_15 flex-row justify-between">
          <span class="text-group_15">福利体系</span>
          <div class="box_13 flex-col"></div>
        </div>
      </div>
      <img class="box_14" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/t_5.png')"/>

      <div class="box_15 flex-col">
        <div class="section_2 flex-row justify-between">
          <div class="box_16 flex-col"></div>
          <div class="image-text_19 flex-row justify-between">
            <span class="text-group_19">职场通道</span>
            <div class="block_2 flex-col"></div>
          </div>
        </div>
        <img class="section_3" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/t_7.png')"/>
      </div>
      <div class="box_17 flex-row justify-between">
        <div class="section_5 flex-col"></div>
        <div class="image-text_20 flex-row justify-between">
          <span class="text-group_20">培养体系</span>
          <div class="block_4 flex-col"></div>
        </div>
      </div>
      <img class="text-wrapper_15" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/t_8.png')"/>

      <div class="box_18 flex-col">
        <div class="group_14 flex-row justify-end">
          <span class="text_57">应届生培训</span>
          <div class="box_19 flex-col"></div>
          <div class="box_20 flex-col"></div>
        </div>
        <img class="text-wrapper_16" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/t_9.png')"/>

      </div>
    </div>

    <div class="bas_class" v-if="basicInformationShow || jobOpeningsShow">
      <div class="block_1 flex-row">
        <div class="text-wrapper_5 flex-col justify-between">
          <span class="text_19">当前位置：首页&nbsp;&gt;&nbsp;人力资源</span>
          <span class="text_20">企业基本情况</span>
        </div>
        <div class="text-wrapper_6_be">
          <transition  name="slide">
            <div class="text-wrapper_6 flex-col" v-if="telshow">
              <span class="text_21">4001-300-137</span>
            </div>
          </transition>
        </div>
        <div class="box_8_1">
          <div class="box_4 flex-row" style="cursor:pointer" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
            <div class="image-text_1 flex-col justify-between">
              <img class="label_1" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/icon_lxfs.png')"/>
              <span class="text-group_1">业务咨询</span>
            </div>
          </div>
        </div>
      </div>
      <img id="block_2" class="image_2" referrerpolicy="no-referrer" :src="require('@/assets/humanResources/img/dx_1.jpg')"/>
      <div class="block_2 flex-col" >
        <div class="image-text_2 flex-row">
          <div class="text-group_2 flex-row">
            <span class="text_22">ABOUT&nbsp;US</span>
            <span class="text_23">关于先河</span>
          </div>
          <div class="box_5 flex-col"></div>
        </div>
        <div class="block_3 flex-col"></div>
        <div class="text-wrapper_7">
          <!-- <span class="text_24">河北先河环保科技股份有限公司（股票代码300137）成立于1996年，注册资本5.51亿，是集环境监测、数据服务、综合治理为一体的集团化公司。</span>
          <span class="paragraph_1">公司于2010年11月成功登陆创业板，成为国内监测仪器仪表行业率先上市的企业。<br /><br />目前，公司总资产24亿元，员工2000人，下辖14家子公司和北京、石家庄、成都、深圳、美国五个个研发中心；业务涵盖生态环境智慧监测、运<br />维服务、社会化检测、环境大数据分析与决策支持、双碳全产业链服务、VOCs治理及污水治理七大领域。<br /><br
          /></span>
          <span class="text_25"
          >先河是国家创新型企业（试点）、国家企业技术中心、国家火炬计划重点高新技术企业、国家国际科技合作基地、环境监测仪器系统技术国家地方</span
          >
          <span class="paragraph_2"><br /></span>
          <span class="text_26"
          >联合工程实验室、全国博士后科研工作站、河北省环境监测装备工程技术研究中心、河北省企业技术中心，先后被授予河北省政府质量奖、河北省</span
          >
          <span class="paragraph_3"
          ><br />“巨人计划”创新创业团队、河北省技术创新型企业等荣誉称号，连续多次被评为中国环保产业骨干企业、国家重合同守信用企业。<br /><br
          /></span>
          <span class="text_27"
          >先河在公司成立之初就确立&nbsp;“创新引领发展”的理念，坚持以产品技术创新和商业模式创新驱动自身快速发展，实现由环境监测设备研发制造商成</span
          >
          <span class="paragraph_4"
          ><br />功转型成为政府提供大数据决策咨询的服务商，目前正进一步谋划成为区域生态环境综合治理的全产业链服务商。近年来先河环保凭借超前创新、<br />转型升级以及稳健经营，取得了令人瞩目的发展成就。2019年依托“转型、国际化、资本”三大战略，实现经营业绩连续8年保持30%以上增速。</span
          > -->
          <span class="text_24">
            河北先河环保科技股份有限公司（股票代码300137）成立于1996年，注册资本5.51亿，是集环境监测、数据服务、综合治理为一体的集团化公司。
            公司于2010年11月成功登陆创业板，成为国内监测仪器仪表行业率先上市的企业。<br /><br />目前，公司总资产24亿元，员工2000人，下辖14家子公司和北京、石家庄、成都、深圳、美国五个个研发中心；业务涵盖生态环境智慧监测、运维服务、社会化检测、环境大数据分析与决策支持、双碳全产业链服务、VOCs治理及污水治理七大领域。
            <br /><br />先河是国家创新型企业（试点）、国家企业技术中心、国家火炬计划重点高新技术企业、国家国际科技合作基地、环境监测仪器系统技术国家地方
            联合工程实验室、全国博士后科研工作站、河北省环境监测装备工程技术研究中心、河北省企业技术中心，先后被授予河北省政府质量奖、河北省
            “巨人计划”创新创业团队、河北省技术创新型企业等荣誉称号，连续多次被评为中国环保产业骨干企业、国家重合同守信用企业。<br /><br/>
            先河在公司成立之初就确立&nbsp;“创新引领发展”的理念，坚持以产品技术创新和商业模式创新驱动自身快速发展，实现由环境监测设备研发制造商成
            功转型成为政府提供大数据决策咨询的服务商，目前正进一步谋划成为区域生态环境综合治理的全产业链服务商。近年来先河环保凭借超前创新、转型升级以及稳健经营，取得了令人瞩目的发展成就。2019年依托“转型、国际化、资本”三大战略，实现经营业绩连续8年保持30%以上增速。
          </span>
        </div>
        <div class="block_4 flex-row">
          <div class="box_6 flex-col"></div>
          <span class="text_28">先河环保是</span>
        </div>
        <div class="grid_1 flex-row alltime">
          <div class="text-wrapper_8 flex-col">
            <span class="text_29">国家创新型企业（试点）</span>
            <s></s>
          </div>
          <div class="text-wrapper_9 flex-col">
            <span class="text_30">国家企业技术中心</span>
            <s></s>
          </div>
          <div class="text-wrapper_10 flex-col">
            <span class="text_31">国家火炬计划重点高新技术企业</span>
            <s></s>
          </div>
          <div class="text-wrapper_11 flex-col">
            <span class="text_32">国家国际科技合作基地</span>
            <s></s>
          </div>
          <div class="text-wrapper_12 flex-col">
            <span class="text_33">国家重合同守信用企业</span>
            <s></s>
          </div>
        </div>
        <div class="grid_1 flex-row">
          <div class="text-wrapper_13 flex-col">
            <span class="text_34">环境监测仪器系统技术国家地方联合工程实验室</span>
            <s></s>
          </div>
          <div class="text-wrapper_14 flex-col">
            <span class="text_35">全国博士后科研工作站</span>
            <s></s>
          </div>
          <div class="text-wrapper_15 flex-col">
            <span class="text_36">河北省环境监测装备工程技术研究中心</span>
            <s></s>
          </div>
          <div class="text-wrapper_16 flex-col">
            <span class="text_37">河北省企业技术中心</span>
            <s></s>
          </div>
        </div>
        <div class="grid_1 flex-row">
          <div class="text-wrapper_17 flex-col">
            <span class="text_38">河北省政府质量奖</span>
            <s></s>
          </div>
          <div class="text-wrapper_18 flex-col">
            <span class="text_39">河北省“巨人计划”创新创业团队</span>
            <s></s>
          </div>
          <div class="text-wrapper_19 flex-col">
            <span class="text_40">河北省技术创新型企业</span>
            <s></s>
          </div>
        </div>
      </div>
      <div class="block_5 flex-col" id="job">
        <div class="image-text_3 flex-row">
          <div class="text-group_3 flex-row">
            <span class="text_41">POSITION</span>
            <span class="text_42">招聘职位</span>
          </div>
          <div class="group_2 flex-col"></div>
        </div>
        <div class="group_33 flex-col"></div>
        <div class="grid_2 flex-row">
          <div
              class="list-items_1 flex-col alltime"
              v-for="(item, index) in jobList"
              :key="index"
          >
            <span class="text_43" v-html="item.job_name"></span>
            <div class="box_7 flex-row">
              <div class="image-text_4 flex-row justify-between">
                <img
                    class="thumbnail_3"
                    referrerpolicy="no-referrer"
                    :src="require('@/assets/humanResources/img/icon_dz.png')"
                />
                <span class="text-group_4" v-html="item.work_location" :title="'工作地点：'+item.education"></span>
              </div>
              <div class="image-text_5 flex-row justify-between">
                <img
                    class="thumbnail_4"
                    referrerpolicy="no-referrer"
                    :src="require('@/assets/humanResources/img/icon_xl.png')"
                />
                <span class="text-group_5" v-html="item.education" :title="'要求学历：'+item.education"></span>
              </div>
              <img
                  class="thumbnail_5"
                  referrerpolicy="no-referrer"
                  :src="require('@/assets/humanResources/img/icon_rs.png')"
              />
              <span class="text_44" v-html="item.department" :title="'公司/部门：'+item.department"></span>
            </div>
            <span class="text_45">专业方向</span>
            <span class="text_46" v-html="item.major_direction"></span>
            <span class="text_47">经验要求</span>
            <span class="text_48" v-html="item.experience"></span>
            <div class="box_8 flex-col"></div>
            <div class="text-wrapper_20">
              <span class="text_49">简历投递邮箱：</span>
              <span class="text_50">xhrs&#64;sailhero.com.cn</span>
            </div>
            <s></s>
          </div>
        </div>
      </div>
      <div class="pagination flex-col">
        <Pagination v-show="total>0" :total="total" :background="false" :page.sync="params.pageIndex" :limit.sync="params.pageSize"
                    @pagination="getData"/>
      </div>
    </div>



  </div>
</template>
<script>
import Pagination from './components/Pagination'
export default {
  components: { Pagination },
  data() {
    return {
      params:{
        pageIndex:1,
        pageSize:6,
      },
      total:0,
      jobList: [],
      indexShow:true,//首页show
      emailShow:false,//简历投递邮箱show
      basicInformationShow:false,//企业基本情况show
      jobOpeningsShow:false,//招聘岗位show
      telshow:false,
    };
  },
  methods: {
    //获取招聘职位列表
    getData() {
      var _this = this;
      _this.$api.post(
          "/Client/getOpenPositions",
          {pageSize:_this.params.pageSize,pageIndex:_this.params.pageIndex},
          function (res) {
            if (res.code == "200") {
              _this.total = res.count;
              _this.jobList = res.data;
            }
          }
      );
    },
    showIndex(){
      var _this = this;
      if (_this.indexShow === true){
      }else {
        _this.indexShow = true;
        _this.basicInformationShow = false;
        _this.emailShow = false;
        _this.jobOpeningsShow = false;
      }
    },
    showEmail(){
      var _this = this;
      if (_this.emailShow === true){
      }else {
        _this.emailShow = true;
        _this.basicInformationShow = false;
        _this.indexShow = false;
        _this.jobOpeningsShow = false;
      }
    },
    showBasicInformation(){
      var _this = this;
      if (_this.basicInformationShow === true){
      }else {
        _this.basicInformationShow = true;
        _this.indexShow = false;
        _this.emailShow = false;
        _this.jobOpeningsShow = false;
      }

      _this.$nextTick(() => {
        setTimeout(() => {
          let anchor = document.getElementById("block_2");
          anchor.scrollIntoView({ behavior: "smooth" });//跳转到指定位置
        }, 300);
      });
    },
    showJobOpenings(){
      var _this = this;
      if (_this.jobOpeningsShow === true){
      }else {
        _this.jobOpeningsShow = true;
        _this.indexShow = false;
        _this.emailShow = false;
        _this.basicInformationShow = false;
      }

      _this.$nextTick(() => {
        setTimeout(() => {
          let anchor = document.getElementById("job");
          anchor.scrollIntoView({ behavior: "smooth" });//跳转到指定位置
        }, 300);
      });


    },
    handleMouseEnter(){
        let that = this;
        that.telshow = true;
    },
    handleMouseLeave(){
        let that = this;
        that.telshow = false;
    }
  },
  mounted() {
    let that = this;
    that.getData();
  },
};
</script>
<style scoped>
  @import '../../../assets/humanResources/css/index.css';
  .slide-enter-active, .slide-leave-active {
        transition: transform 0.5s;
    }
    .slide-enter, .slide-leave-to /* .slide-leave-active for <2.1.8 */ {
        transform: translateX(22.53vw);
    }
 </style>
